/* Sashet — ambient scroll-reveal + cart-count pop
   Keeps CSS in charge of the actual motion; this file only flips
   data-visible="true" on elements as they enter the viewport. */
(function () {
  'use strict';

  // Respect reduced-motion
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.setAttribute('data-reduce-motion', 'true');
    return;
  }

  // Auto-tag canonical sections if the theme author hasn't already
  const autoTargets = [
    '.hero__promo-card',
    '.brand-intro',
    '.box-strip',
    '.big-headline',
    '.feature',
    '.testimonials',
    '.cta-strip',
    '.advisory',
    '.pp',
    '.pp-tabs',
    '.pp-upgrade',
    '.how-to-use',
    '.fpp',
    '.shop-hero',
    '.hc-intro',
    '.hc-split',
    '.hc-team-feature',
    '.contact-hero',
    '.contact-body'
  ];
  autoTargets.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (!el.hasAttribute('data-reveal') && !el.hasAttribute('data-reveal-stagger')) {
        el.setAttribute('data-reveal', '');
      }
    });
  });

  // Stagger groups. On desktop, .product-grid keeps its original block-stagger reveal.
  // On mobile we switch the grid to per-card lazy reveal (see below), so omit it here.
  const isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  const staggerTargets = [
    '.info-columns__stage',
    '.fpp__cards',
    '.how-to-use__steps'
  ];
  if (!isMobile) {
    staggerTargets.unshift('.product-grid');
  }
  staggerTargets.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (!el.hasAttribute('data-reveal-stagger')) {
        el.setAttribute('data-reveal-stagger', '');
        el.removeAttribute('data-reveal');
      }
    });
  });

  // Mobile only: reveal each product card individually as it enters the viewport.
  // Cards already in view on initial load stay un-tagged so the first product renders instantly.
  if (isMobile) {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('.product-grid .product-card').forEach(function (card) {
      const rect = card.getBoundingClientRect();
      if (rect.top >= vh * 0.9) {
        card.setAttribute('data-reveal', '');
      }
    });
  }

  if (!('IntersectionObserver' in window)) {
    // Fallback: just reveal everything immediately
    document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(function (el) {
      el.setAttribute('data-visible', 'true');
    });
    return;
  }

  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.setAttribute('data-visible', 'true');
        io.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.08
  });

  document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(function (el) {
    io.observe(el);
  });
})();

/* Sticky nav: show after scrolling past 200px (desktop only) */
(function () {
  if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) return;
  var threshold = 200;
  var on = false;
  function update() {
    var should = window.scrollY > threshold;
    if (should !== on) {
      on = should;
      document.body.classList.toggle('has-sticky-nav', should);
    }
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();
